<template>
  <div class="qr">
    <div class="default-text-main-page text">
      <form ref="qrForm" class="qr-form" @submit.prevent="onSubmit">
        <h2 class="default-text-main-page-header qr-header">
          Wpisz kod znajdujący się poniżej kodu QR
        </h2>
        <input v-model="code" class="default-input-form" borderless autofocus />
        <button class="default-form-button" type="submit">Wyślij</button>
      </form>
    </div>
    <div class="default-text-main-page text">
      <h2 class="default-text-main-page-header">Przejdź do wydarzenia!</h2>
      <p>
        Zeskanuj kod QR albo przepisz kod widoczny poniżej i przejdź do swojego
        wydarzenia.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores';
import { ref } from 'vue';
import router from '@/router';
import { useToast } from 'vue-toastification';

const authStore = useAuthStore();
const code = ref('');
const toast = useToast();

const onSubmit = async () => {
  if (code.value === '') {
    toast.error('Pole z kodem nie może być puste');
    return;
  }

  try {
    const userCode = code.value.toLocaleLowerCase().trim();
    await authStore.trySetupData(userCode);
    const routeData = router.resolve({
      name: 'Event',
      params: { id: userCode },
    });
    window.location.replace(
      'https://app.wspomnieniazwesela.pl' + routeData.href,
    );
  } catch (err) {
    toast.error('Błędny kod');
  }
};
</script>

<style lang="scss" scoped>
.qr {
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 25px 0;
  gap: 15px 55px;
  margin: 0 auto;

  @media screen and (max-width: 600px) {
    flex-wrap: wrap-reverse;
    justify-content: center;
  }

  .qr-header {
    text-align: center;
    font-size: 30px;

    @media screen and (max-width: 600px) {
      font-size: 22px;
    }
  }

  .qr-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .text {
    max-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    @media screen and (max-width: 600px) {
      justify-content: center;
      align-items: center;
    }

    p {
      @media screen and (max-width: 600px) {
        text-align: center;
      }
    }
  }
}
</style>
